module.exports = __webpack_public_path__ + "fonts/Barlow-SemiBold.f472fc07.ttf";